<script>
export default {
  props: {
    selectedFaturamentoItens: Array,
    selectedPagamentoItens: Array,
    guiasConciliacaoAutomatica: Array
  },
  data () {
    return {
      count: 0,
      icons: {
        swapHorizontal: 'fa-arrows-alt-h'
      },
      conciliarDialogOpen: false
    }
  },
  components: {
  },
  computed: {
    valorPagoPagamentoItens () {
      return this.selectedPagamentoItens?.map(pagamentoItem => pagamentoItem.valorPago).reduce((parcial, elemento) => parcial + elemento, 0)
    },
    valorPagoFaturamentoItens () {
      return this.selectedFaturamentoItens?.map(faturamentoItem => faturamentoItem.valorPago).reduce((parcial, elemento) => parcial + elemento, 0)
    },
    valorInformadoPagamentoItens () {
      return this.selectedPagamentoItens?.map(pagamentoItem => pagamentoItem.valorInformado).reduce((parcial, elemento) => parcial + elemento, 0)
    },
    valorInformadoFaturamentoItens () {
      return this.selectedFaturamentoItens?.map(faturamentoItem => faturamentoItem.valor).reduce((parcial, elemento) => parcial + elemento, 0)
    },
    valorGlosadoPagamentoItens () {
      return this.selectedPagamentoItens?.map(pagamentoItem => pagamentoItem.valorGlosado).reduce((parcial, elemento) => parcial + elemento, 0)
    },
    valorGlosadoFaturamentoItens () {
      return this.selectedFaturamentoItens?.map(faturamentoItem => faturamentoItem.valorGlosado).reduce((parcial, elemento) => parcial + elemento, 0)
    },
    tooltipBotaoConciliar () {
      if (this.selectedPagamentoItens?.length === 0) return 'Selecione um item de pagamento'
      if (this.selectedFaturamentoItens?.length === 0) return 'Selecione um item de faturamento'
      if (this.selectedItemInGuiaAutomatica) return 'Foram selecionados itens de uma guia com status: "Conciliação Automática"'
      if (this.isPagamentoItensConciliados) return 'Foram selecionados itens de pagamento já conciliados'
      else return 'Foram selecionados itens de faturamento já conciliados'
    },
    disableBotaoConciliar () {
      return (
        this.selectedFaturamentoItens?.length === 0 ||
        this.selectedPagamentoItens?.length === 0 ||
        this.selectedItemInGuiaAutomatica ||
        this.isPagamentoItensConciliados ||
        (this.isFaturamentoItensConciliados && (!this.isPagamentoItensRecurso && !this.isPagamentoItensEstorno))
      )
    },
    selectedItemInGuiaAutomatica () {
      return this.selectedPagamentoItens?.some(item => this.guiasConciliacaoAutomatica?.includes(item.pagamentoGuiaId))
    },
    isPagamentoItensConciliados () {
      return this.selectedPagamentoItens?.some(item => (item.conciliacaoItens?.length || 0) > 0)
    },
    isFaturamentoItensConciliados () {
      return this.selectedFaturamentoItens?.some(item => (item.conciliacaoItens?.length || 0) > 0)
    },
    isPagamentoItensRecurso () {
      return this.selectedPagamentoItens?.every(item => item.tipoRegistro === 'recurso')
    },
    isPagamentoItensEstorno () {
      return this.selectedPagamentoItens?.every(item => item.tipoRegistro === 'estorno')
    },
    totalGlosadoPagamentoItens () {
      return this.selectedPagamentoItens?.reduce((total, item) => total + item.valorGlosado, 0) || 0
    },
    isGlosaMaiorFaturado () {
      return this.totalGlosadoPagamentoItens > this.valorInformadoFaturamentoItens
    },
    isValoresInformadosDivergentes () {
      return Math.abs(this.valorInformadoFaturamentoItens - this.valorInformadoPagamentoItens) > 0.001
    },
    formatValorGlosadoPagamentoItems () {
      return this.formatCurrency(this.valorGlosadoPagamentoItens)
    },
    formatValorInformadoFaturamentoItems () {
      return this.formatCurrency(this.valorInformadoFaturamentoItens)
    },
    formatValorInformadoPagamentoItems () {
      return this.formatCurrency(this.valorInformadoPagamentoItens)
    },
    conciliarDialogMessage () {
      if (this.isGlosaMaiorFaturado) {
        return `Valor glosado (${this.formatValorGlosadoPagamentoItems}) é maior que o valor informado (${this.formatValorInformadoFaturamentoItems})`
      } else if (this.isValoresInformadosDivergentes) {
        return `Valor informado da conta (${this.formatValorInformadoFaturamentoItems}) não confere com o valor informado do demonstrativo (${this.formatValorInformadoPagamentoItems}).`
      } else {
        return 'Esta ação irá forçar a conciliação dos itens selecionados.'
      }
    }
  },
  methods: {
    handleClickBotaoConciliar () {
      if (this.isGlosaMaiorFaturado || this.isValoresInformadosDivergentes) {
        this.conciliarDialogOpen = true
      } else {
        this.$emit('clickConciliar')
        this.conciliarDialogOpen = false
      }
    },
    formatCurrency (value) {
      return isNaN(value) ? '-' : new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' }).format(value)
    }
  }
}
</script>

<template>
  <div class="d-flex">
    <div>
      <div class="d-flex">
        <v-menu left >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-subheader>Opções</v-subheader>
            <v-list-item
              @click="() => conciliarDialogOpen = true"
              :disabled="this.selectedFaturamentoItens?.length === 0 || this.selectedPagamentoItens?.length === 0"
            >
              Conciliar restante
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tooltip top :disabled="!disableBotaoConciliar">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                class="mx-2 mt-1"
                color="primary"
                small
                :disabled="disableBotaoConciliar"
                @click="handleClickBotaoConciliar"
              >
                CONCILIAR
              </v-btn>
            </div>
          </template>
          <span>{{ tooltipBotaoConciliar }}</span>
        </v-tooltip>
      </div>
    </div>
    <div style="height: 48px; width: 100%;" class="d-flex align-center justify-center">
      <div class="d-flex justify-end" style="width: calc(50% - 137px);">
        <p class="ma-0 pr-4 font-size-2">Valor Informado: <span class="font-weight-bold">{{ valorInformadoPagamentoItens | formatPrice }}</span></p>
        <p class="ma-0 pr-4">Valor Glosado: <span class="red--text font-weight-bold">{{ valorGlosadoPagamentoItens | formatPrice }}</span></p>
        <p class="ma-0">Valor Pago: <span class="green--text font-weight-bold">{{ valorPagoPagamentoItens | formatPrice }}</span></p>
      </div>
      <v-icon class="px-4">{{ icons.swapHorizontal }}</v-icon>
      <div class="d-flex align-center justify-space-between" style="width: 50%;">
        <div class="d-flex">
          <p class="ma-0 pr-4">Valor Informado: <span class="font-weight-bold">{{ valorInformadoFaturamentoItens | formatPrice }}</span></p>
          <p class="ma-0 pr-4">Valor Glosado: <span class="red--text font-weight-bold">{{ valorGlosadoFaturamentoItens | formatPrice }}</span></p>
          <p class="ma-0">Valor Pago: <span class="green--text font-weight-bold">{{ valorPagoFaturamentoItens | formatPrice }}</span></p>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="conciliarDialogOpen"
      @click:outside="() => {
        conciliarDialogOpen = false
      }"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          Conciliar itens
        </v-card-title>
        <v-card-text>
          {{ this.conciliarDialogMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="() => conciliarDialogOpen = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="() => {
              this.$emit('clickConciliar')
              this.conciliarDialogOpen = false
            }"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
  p {
    font-size: 14px
  }
</style>
